import { useEffect, useLayoutEffect, useRef } from 'react'
import Header from 'components/Assessment/Header'
import Footer from 'components/Assessment/Footer'
import QuestionContainer from 'components/Assessment/QuestionContainer'

let isScriptAdded = false
const Assessment = () => {
  const highLighterRef = useRef<any>(null)
  const removeHighlightRef = useRef<any>(null)
  useLayoutEffect(() => {
    document.body.style.backgroundColor = 'unset'

    return () => {
      document.body.style.backgroundColor = '#194792'
    }
  }, [])

  const onClickHighLighter = (setIsScreenMarked: Function) => {
    const highlightArea = document.getElementById('highlight')

    if (highlightArea) {
      highLighterRef.current = new (window.TextHighlighter as any)(
        highlightArea as HTMLElement,
        { setIsScreenMarked }
      )
    }
  }

  const removeHighlight = () => {
    const highlightArea = document.getElementById('highlight')

    if (highlightArea) {
      removeHighlightRef.current = new (window.TextHighlighter as any)(
        highlightArea as HTMLElement,
        { isRemoveHighlight: true, setIsScreenMarked: () => {} }
      )
    }
  }

  const onDestroyHighlighterRemover = () => {
    const highlightArea = document.getElementById('highlight')

    if (highlightArea) {
      removeHighlightRef?.current?.destroy()
    }
  }

  const onRemoveHighlighter = () => {
    const highlightArea = document.getElementById('highlight')

    if (highlightArea) {
      highLighterRef?.current?.removeHighlights(highlightArea)
    }
  }

  const onDestroyHighlighter = () => {
    const highlightArea = document.getElementById('highlight')

    if (highlightArea) {
      highLighterRef?.current?.destroy()
    }
  }

  useEffect(() => {
    if (!isScriptAdded) {
      isScriptAdded = true
      const calculatorScript = document.createElement('script')
      calculatorScript.id = 'desmos-calc'
      calculatorScript.src = '/calculator.js'
      document.head.appendChild(calculatorScript)
    }
  }, [])

  return (
    <>
      <Header />
      <QuestionContainer onRemoveHighlighter={onRemoveHighlighter} />
      <Footer
        onClickHighLighter={onClickHighLighter}
        onRemoveHighlighter={removeHighlight}
        onDestroyHighlighter={onDestroyHighlighter}
        onDestroyHighlighterRemover={onDestroyHighlighterRemover}
        onRemoveAllHighlights={onRemoveHighlighter}
      />
    </>
  )
}

export default Assessment
